import React, { useEffect, useState } from 'react'
import client from '../../client/Client';
import HeaderBanner from '../ui/HeaderBanner';

interface content {
  FullAccommodationDoubleRoom: string,
  FullAccommodationsingleroomsupplement: string,
  FullAccommodationBaby: string,
  FullAccommodationChild1: string,
  FullAccommodationChild2: string,
  FullAccommodationChild3: string,
  HotelName: string
}

interface dataType {
  AccomodationDeadLine: string,
  AccomodationForm: string,
  FormAccommodation: Array<{
    children: Array<{
      text: string;
    }>
  }>
}

const Accomodation = () => {
  const [data, setData] = useState<dataType>({
    AccomodationDeadLine: "",
    AccomodationForm: "",
    FormAccommodation: []
  })
  const [FullAccomodation, setFullAccomodation] = useState<content[]>([])

  useEffect(() => {
    client.fetch('*[_type == "AccomodationANDRegistration"]')
      .then((result) => {
        setData(result[0]);
        result[0].FullAccomodation.length > 0 ? setFullAccomodation(result[0].FullAccomodation) : <></>
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [])
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 pt-32 pb-24">
      <div className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1" aria-hidden="true">
        <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>
      
      <HeaderBanner title='Accommodation' />
      
      <div className="text-left space-y-8 pt-12">
        {/* Accommodation Instructions Section */}
        {data?.FormAccommodation?.length > 0 && (
          <div className="bg-blue-50 border-l-4 border-blue-901 p-6 rounded-lg shadow-sm">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-800 mb-2">
              Accommodation Instructions
            </h1>

            <div className="space-y-4">
              {data.FormAccommodation.map((block: any, i: number) => (
                <p key={i} className="text-gray-700 leading-relaxed">
                  {block.children.map((child: any, childIdx: number) => {
                    // Find link definition if a mark is defined
                    const linkData =
                      child.marks && child.marks.length > 0
                        ? block.markDefs.find(
                            (def: any) => def._key === child.marks[0]
                          )
                        : null;

                    // Detect text style marks
                    const hasStrong = child.marks?.includes("strong");
                    const hasUnderline = child.marks?.includes("underline");

                    // Apply style based on mark combination
                    let textClasses = "";
                    if (hasStrong && hasUnderline) {
                      textClasses = "font-semibold text-red-600"; // bold + red
                    } else if (hasStrong) {
                      textClasses = "font-semibold"; // bold
                    } else if (hasUnderline) {
                      textClasses = "underline"; // underline
                    }

                    // Styled text element
                    const content = (
                      <span key={childIdx} className={textClasses}>
                        {child.text}
                      </span>
                    );

                    // If it's a link, wrap with <a>
                    if (linkData) {
                      return (
                        <a
                          key={childIdx}
                          href={linkData.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-901 hover:text-blue-800 font-medium underline transition-colors duration-200"
                        >
                          {content}
                        </a>
                      );
                    }

                    // Default: return styled text
                    return content;
                  })}
                </p>
              ))}
            </div>
          </div>
        )}



        {/* Accommodation Form Button */}
        {data && data.AccomodationDeadLine && data.AccomodationForm && (
          <div className="text-center space-y-4">
            <div className='max-w-lg mx-auto'>
              <a 
                href={data.AccomodationForm}
                className='bg-white border-2 border-blue-901 rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:bg-blue-901 group text-center block'
              >
                <span className='text-blue-901 group-hover:text-white font-semibold text-lg'>
                  Accommodation Form
                </span>
              </a>
            </div>
            <p className="text-gray-700 text-lg leading-relaxed">
              The accommodation file should be fulfilled before 
              <span className="font-semibold text-red-600">{ " "+ data.AccomodationDeadLine}</span> to benefit from conference prices.
            </p>
          </div>
        )}

        {/* Hotel Accommodation Tables */}
        {FullAccomodation.length > 0 && (
          <div className="space-y-8">
            {FullAccomodation.map((item, index) => (
              <div key={index} >
                <h1 className='w-full text-center text-2xl font-semibold text-red-500 mb-6'>
                  {item.HotelName}
                </h1>
                
                <table className="rounded-t-lg w-full mx-auto bg-gray-200 text-gray-800">
                  <tbody>
                    <tr>
                      <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">Double Room</td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                        <span className='w-full grid justify-items-center'>{item.FullAccommodationDoubleRoom}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">Single Room Supplement</td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                        <span className='w-full grid justify-items-center'>{item.FullAccommodationsingleroomsupplement}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">Baby (0 to 1.99 year)</td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                        <span className='w-full grid justify-items-center'>{item.FullAccommodationBaby}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">Child (2 to 11.99 years) lodged with 2 adults</td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                        <span className='w-full grid justify-items-center'>{item.FullAccommodationChild1}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">Child (2 to 11.99 years) with 1 adult</td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                        <span className='w-full grid justify-items-center'>{item.FullAccommodationChild2}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className="px-4 py-3 text-left border-b-2 border-gray-300 font-medium">2 Children (2 to 11.99 years) without adults</td>
                      <td className="px-4 py-3 bg-gray-100 border-b border-gray-200">
                        <span className='w-full grid justify-items-center'>{item.FullAccommodationChild3}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        )}

        {/* Additional Information Section */}
        <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg">
          <h3 className="text-lg font-semibold text-red-600 mb-2">
            Need Assistance with Accommodation?
          </h3>
          <p className="text-gray-700">
            For any questions regarding accommodation, please contact:{' '}
            <a className='text-blue-901 hover:text-blue-800 font-medium underline' href='mailto:info@ssd-multiconf.org'>
              info@ssd-multiconf.org
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Accomodation